import { CoordinatorService } from './coordinator.service';
import { ScriptItem } from './script-x-item';
import { CitationParams } from './citation-params';

// https://www.zotero.org/styles

export class ScriptCitation {
    #coords: CoordinatorService;

    constructor(coords: CoordinatorService) {
        this.#coords = coords;
    }

    cite(
        itm: ScriptItem,
        {
            inDetail,
            omitAuthors,
            isShort,
            isPlainText,
        }: {
            inDetail?: boolean;
            omitAuthors?: boolean;
            isShort?: boolean;
            isPlainText?: boolean;
        } = {},
    ) {
        const c = this.#coords.citeEngine;

        const data = new CitationParams(this.#coords, itm, !!inDetail).resp;
        const rMap = new Map<string, string>();

        ['title', 'container-title'].forEach((k) => {
            const t = data[k];
            if (t?.tag) {
                rMap.set(t.tag, t.value);
                data[k] = t.tag;
            }
        });

        const issued = data['issued'];
        if (issued) {
            const ls = issued['date-parts'][0];
            if (!ls[1]) {
                const tagYear = ls[0];
                rMap.set(`${tagYear}`, `${this.#coords.highlight$.runYear(ls[0])}`);
                ls[0] = tagYear;
            }
        }

        if (!omitAuthors && !isShort) {
            const authorLs = data['authorLs'] as Array<string>;
            if (authorLs?.length) {
                for (let i = 0; i < authorLs.length; i++)
                    authorLs[i] = this.#coords.highlight$.run(authorLs[i], 'authorLs');

                this.#coords.utils$.highlightFirstLastAuthor(authorLs);
                let counter = 1;
                const tagLs = authorLs.map((a, i) => {
                    a = a.replace(/<span.*?<\/span>/g, (match, p1) => {
                        const key = `@@@au${counter++}@@@`; // Generate a unique key like A1
                        rMap.set(key, match); // Store the extracted content in the map
                        return key; // Replace the match with the generated key
                    });

                    return { family: a.split(',')[0], given: a.split(',')[1] || '' };
                });

                data['author'] = tagLs;
            }
        }

        delete data['editor'];
        c.set(data);

        let output = c.format('bibliography', {
            format: isPlainText ? 'text' : 'html',
            template: this.#coords.display$.currentCitationStyle,
            lang: 'en-US',
        });

        output = output.replace(/<div[^>]*>|<\/div>/gi, '');

        rMap.forEach((txt, tag) => {
            output = output.replace(tag, txt || '');
        });

        if (!isShort) {
            const doi = itm.get('doi');
            doi && (output += ` <a target="_blank" href="https://doi.org/${doi}">${doi}</a>`);
            if (!doi) {
                const url = itm.get('url');
                url && (output += ` <a target="_blank" href="${url}">${url}</a>`);
            }
        }

        return output;
    }
}
